import { client } from "../client";
import { addMusicCategory } from "./addTrack";

/**
 * The area list and music list arrive concatenated, and the last "area" before
 * the first song is really the first music category (e.g. "==Ace Attorney==").
 * Move it out of the areas and open it as a collapsible category so the songs
 * that follow nest under it -- instead of leaving it as a lone track that just
 * stops the music when clicked.
 */
export const fix_last_area = () => {
  if (client.areas.length > 0) {
    const malplaced = client.areas.pop().name;
    const areas = document.getElementById("areas")!;
    areas.removeChild(areas.lastChild);
    addMusicCategory(malplaced);
  }
};
